/**
 * 技术性能埋点（与 @/utils/tracker 业务埋点分离）
 *
 * @description
 * - H5 整页冷启 / SPA：`h5_cold_load_perf`、`h5_spa_route_perf`
 * - 阅读器首进：`reader_perf`
 * - 统一经 ARMS `performance` 分组上报
 */

export { EPerformanceEvents } from './events';
export { reportPerformanceEvent } from './report';
export { getDocumentDclDurationMs, getNavElapsedMs, getPageLoadElapsedMs } from './loading-timing';
export { onH5PathnameChange, consumeH5ColdStart } from './h5-perf-session';
export { reportH5ColdLoadPerf, scheduleH5SpaRoutePerf } from './h5';
export type { IScheduleH5SpaRoutePerfParams } from './h5';
export {
    logReaderPerfTrack,
    logReaderPageLoad,
    logReaderApiLoad,
    logReaderContentRender,
    logReaderMount,
    logReaderProfileHydration,
} from './reader/event';
export type { IReaderPerfTrackParams } from './reader/event';
